import React from 'react'
import { MeetStepForm } from './form'
import { useTrackCatalogShortAnketaShow } from '../../../../components/amplitude/catalogWizardAnketa/trackCatalogShortAnketaShow'

export const MeetStep = ({ onMeetSubmit }) => {
  useTrackCatalogShortAnketaShow()
  return <MeetStepForm onSubmit={onMeetSubmit} />
}
